/**
 * state format
 *  .applicationContext
 *      .ch {String}
 *      .ss {String}
 *      .cmp {String}
 *      .fullLocationSearchString {String}
 *  .gui
 *      .responsive {String}
 *          ['desktop',|'mobile']
 *      .currentStep {Number}
 *      .currentStepTitle {String}
 *      .currentEditingData {String}
 *      .onpopstateListeners {Object}
 *      .wizardNextautoWatchers {Object}
 *      .wizardButtonNavClicked {Boolean}
 *  .user
 *      .address
 *      .pv
 *      .city
 *      .postalCode
 *      .email
 *  .configuration
 *      .roofArea {Number}
 *      .roofOrientation {Number}
 *      .roofInclination {Number}
 *      .roofTipology {String}
 *      .roofMaterial {String}
 *      .floorsNumber {Number}
 *      .electricityConsumption {String}
 *      .electricityConsumptionPersone {String}
 *      .electricityConsumptionCost {Number}
 *      .houseUsage {String}
 *      .electricCar {Boolean} * 
 *  .map
 *      .refs
 *          .map {google.maps.Map}
 *          .polygon {google.maps.Polygon}
 *      .data {Object}
 *          ...
 *      .staticImageUrl {String}
 *  ...TODO...
 */

export default {
    applicationContext: {
        ch: null,
        ss: null,
        cmp: null,
        fullLocationSearchString: null
    },
    gui: {
        responsive: null,
        currentStep: null,
        currentStepTitle: null,
        currentEditingData: null,
        onpopstateListeners: {},
        wizardNextautoWatchers: {},
        wizardButtonNavClicked: false
    },
    user: {
        address: null,
        pv: null,
        city: null,
        postalCode: null,
        email: null
    },
    configuration: {
        tipo_installazione: null,
        tipo_riscaldamento: null,
        dove_ambiente: null,
        dove_posizione: null,
        alimentazione: null,
        potenza: null,
        termosifoni_valvole: null,
        termosifoni_numero: null,
        marchi: null,
        scarico_4mt_discesa: null,
        box_coibentato: null,
        scarico_di_condensa: null,
        parete_cemento_pietra: null,
        importo_bolletta_gas: null
    },
    map: {
        refs: {
            map: null,
            polygon: null
        },
        data: null,
        staticImageUrl: null
    },
    /**
     * Holds the installation quotations state
     *  .valutazione
     *      defined by the backend, immutable
     *  .uuid
     *      defined by the backend, immutable
     *  .selectedQuotation
     *      defined by the frontend user choices
     *  .selectedImpianto
     *      defined by the frontend user choices
     *  .basic
     *      defined by the backend and the frontend user choices
     */
    quotations: {
        valutazione: {
            basic: null
        },
        uuid: null, // 'bff78db4-c7af-4dd1-bab8-7165d305fd02'
        selectedQuotation: null, // ['basic']
        selectedImpianto: null, // ['basic'|'basic-accumulo'|'basic-s'|'basic-s-accumulo']
        basic: {
            total: null,
            options: {
                accumulatoreProposto: false
            }
        }
    },
    quotationsForm: {
        valid: false,
        nome: null,
        cognome: null,
        email: null,
        telefono: null,
        ragioneSociale: null,
        indirizzo: null,
        numerocivico: null,
        comune: null,
        cap: null,
        provincia: null,
        tipoImmobile: null,
        emailCommerciale: null
    }
};